module.exports = __webpack_public_path__ + "img/about/80243-042.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-042.png
// module id = 40
// module chunks = 0